var _circle, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4993,
    cy: 17.5013,
    r: 14.5833,
    stroke: "#D81B39",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.793V16.043",
    stroke: "#D81B39",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.45833,
    cy: 1.45833,
    rx: 1.45833,
    ry: 1.45833,
    transform: "matrix(1 0 0 -1 16.041 13.125)",
    fill: "#D81B39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfoIcon);
export default __webpack_public_path__ + "static/media/redInfoIcon.b7178e930d500ffaca4908d01a54b2ac.svg";
export { ForwardRef as ReactComponent };